import { colors, fonts } from 'app-v2/design-systems'
import { BORDER, COLOR, SPACING, TEXT } from 'app-v2/design-tokens'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import downIcon from 'app/tu-preferes-king/assets/Down_icon.png'
import type { TPKRestaurantDTO } from 'shared/store/tu-preferes-king'
import { useIntl } from 'react-intl'
import { StyledDropdownItem } from '../styles'
import { SplitSearch } from 'app/assets/icons'
import { breakpoints } from 'app/assets/styles'

export function RestaurantSelector({
    restaurants,
    setRestaurant,
    isMenuOpen,
    setIsMenuOpen,
    setIsOtherMenuOpen
}: {
    restaurants: TPKRestaurantDTO[],
    setRestaurant: (s: TPKRestaurantDTO) => void,
    isMenuOpen: boolean,
    setIsMenuOpen: (b: boolean) => void,
    setIsOtherMenuOpen: (b: boolean) => void
}) {
    const intl = useIntl()
    const [filterText, setFilterText] = useState('')

    const handleSelectRestaurant = (selectedRestaurant: TPKRestaurantDTO) => {
        setRestaurant(selectedRestaurant)
        setFilterText(selectedRestaurant.name)
        setIsMenuOpen(false)
    }

    const [width, setWidth] = useState(window.innerWidth)

    const isSmallScreen = width < breakpoints.xsmallLegacy

    useEffect(() => {
        return window.addEventListener('resize', updateWindowDimensions)
    }, [])

    const updateWindowDimensions = () => setWidth(window.innerWidth)

    const handleInputChange = event => {
        setFilterText(event.target.value)
        if (event.target.value.length > 0) {
            setIsOtherMenuOpen(false)
        }
        if (event.target.value.length > 2) {
            setIsMenuOpen(true)
        } else {
            setIsMenuOpen(false)
        }
    }

    return (
        <RestaurantSelectorInputContainer isSmallScreen={isSmallScreen}>
            <StyledIconContainer>
                <SplitSearch size={30} color={colors.greyBbqBrown} />
            </StyledIconContainer>
            <InputFilter
                value={filterText}
                onChange={handleInputChange}
                placeholder={intl.formatMessage({
                    id: 'tupreferesking.goodies.selectRestaurantCaption'
                })}
                isSmallScreen={isSmallScreen}
            />
            {isMenuOpen && (
                <DropdownMenu isSmallScreen={isSmallScreen}>
                    <ScrollableList>
                        {restaurants
                            .filter(restaurant =>
                                restaurant.name
                                    .toLowerCase()
                                    .includes(filterText.toLowerCase())
                            )
                            .map(restaurant => (
                                <StyledDropdownItem
                                    key={restaurant.name}
                                    onClick={() =>
                                        handleSelectRestaurant(restaurant)
                                    }>
                                    {restaurant.name}
                                </StyledDropdownItem>
                            ))}
                    </ScrollableList>
                </DropdownMenu>
            )}
        </RestaurantSelectorInputContainer>
    )
}

const RestaurantSelectorInputContainer = styled.div`
    display: flex;
    width: ${props => (props.isSmallScreen ? '100%' : '50%')};
    align-items: center;
    border-radius: ${BORDER.RADIUS.M};
    border: 1px solid ${colors.lightGrey};
    background: ${colors.white};
    padding: ${SPACING.XXXS} ${props => (props.isSmallScreen ? 0 : SPACING.XS)}
        ${SPACING.XXS} 0;
    position: relative;
    overflow: visible;
    min-height: 30px;
    max-height: 30px;
`

export const StyledInputText = styled.span`
    font-family: ${fonts.flameSansRegular};
    color: ${props => props.inputTextColor};
    padding: ${SPACING.L} ${SPACING.L} ${SPACING.M};
    text-transform: none;
    font-size: ${TEXT.FONT_SIZE.M};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

const DropdownMenu = styled.ul`
    position: absolute;
    top: calc(100% + 5px);
    width: ${props => (props.isSmallScreen ? '90%' : '95%')};
    background: ${colors.white};
    border: 1px solid ${colors.lightGrey};
    max-height: 200px;
    overflow-y: visible;
`

const ScrollableList = styled.ul`
    list-style-type: none;
    max-height: 160px;
    overflow: visible;
    overflow-y: auto;
`

const InputFilter = styled.input`
    box-sizing: border-box;
    font-family: ${fonts.flameSansRegular};
    font-size: ${TEXT.FONT_SIZE.M};
    color: ${colors.bbqBrown};
    border: none;
    height: ${props => (props.isSmallScreen ? '50%' : '75%')};
    margin-bottom: 5px;
    &::placeholder {
        color: ${colors.greyBbqBrown};
    }

    &:focus {
        outline: none;
    }
`

const StyledIconContainer = styled.div`
    display: flex;
    margin-top: ${SPACING.XXXS};
    margin-left: ${SPACING.XS};
`
